import rollForwardDate from "../../../game-views/objects/roll_forward_date_function";
import { calcNbrMonthsBtwnDates } from "../../../../objects/CommonUse/nbr_months_btwn_dates_calc";

export const createCDList = (CDObj, currentGameDate) => {
    const gameMonth = currentGameDate.split('-')[1];
    let CDListArr = [];
    const CDList = CDObj.CDList;
    for (let i=0; i<CDList.length; i++){
        const CDListObj = CDList[i];
        const CDMonth = CDListObj.startDate.split('-')[1];
        let highlightRow = false;
        if (CDMonth === gameMonth && CDListObj.startDate !== currentGameDate){
            highlightRow = true;
        }
        let CDMatureDate = "";
        if (CDListObj.startDate <= currentGameDate){
            CDMatureDate = rollForwardDate(CDListObj.startDate, 12);
        }else{
            const CDYear = currentGameDate.split('-')[0];
            CDMatureDate = CDYear + "-" + CDMonth;
        }
        let nbrMonthsUntilMature = 0;
        if (CDMatureDate !== currentGameDate){
            nbrMonthsUntilMature = calcNbrMonthsBtwnDates(currentGameDate, CDMatureDate);
        }
        const actualBoolean = CDListObj.autoRollover === true || CDListObj.autoRollover === "true";
        let amount = +CDListObj.amount - CDListObj.transferAmt;
        if (amount > 0){
            const newCDListObj = {startDate: CDListObj.startDate, amount: +amount, date: CDMatureDate,
                autoRollover: actualBoolean, highlightRow: highlightRow,  
                transferAmt: CDListObj.transferAmt,
                newAutoRollover: actualBoolean, nbrMonthsUntilMature: nbrMonthsUntilMature,
                updtStatus: "",
                fullAmount: CDListObj.amount,
                intAmt: CDListObj.intAmt
            }
            CDListArr.push(newCDListObj);
        }
    }
    if (CDList.length > 1){
        CDList.sort((a, b) => (a.nbrMonthsUntilMature > b.nbrMonthsUntilMature) ? 1 : -1);
    }
    return CDListArr;
}
export default createCDList;